<template>
    <div class="ssqOrdlt">
        <div class="tit">
            <div>
                <span style="font-size: 17px;font-weight: bold;">双色球最新开奖公告(第{{ db[0] && db[0].cycle }}期] </span>
                <span style="font-size: 12px;" v-if="db[0]"> {{ db[0].openTimestamp | handle_ymd }} ({{
                    db[0].openTimestamp
                    | handle_week }})开奖 </span>
            </div>
            <a href="https://caipiao.ip138.com/shuangseqiu/ " target="_blank" style="text-decoration: none;color:#fff">
                <span>更多</span>
            </a>
        </div>
        <div class="intro" v-if="db.length">
            投注总额: {{ db[0].saleMoney }}元
            奖池金额: {{ db[0].remainMoney }}元
        </div>
        <div class="table" v-if="db.length">
            <div class="redBall">
                <div class="tit">红色球</div>
                <div class="num">
                    <span>{{ db[0].openNbr.split(' ').slice(0, 6).join(' ') }}</span>
                </div>
            </div>
            <div class="blueBall">
                <div class="tit">蓝色球</div>
                <div class="num">
                    <span>{{ db[0].openNbr.split(' ')[6] }}</span>
                </div>
            </div>
        </div>
        <div class="table1" v-if="db.length">
            <div>
                <span>期号</span>
                <span>中奖条件</span>
                <span>中奖注数</span>
                <span>投注奖额</span>
            </div>
            <div v-for="(item, index) in list" :key="index">
                <span>{{ item.award }}</span>
                <span>{{ item.ruler }}</span>
                <span>{{ item.awardNbr }}</span>
                <span>{{ item.simpleAwardMoney }}</span>
            </div>
        </div>
        <!-- <div class="intro">
            出球顺序:{{$_.split(db.openNbr,' ',6).toString()}} + {{$_.slice($_.split(db.openNbr,' '),6,7)[0]}}
        </div> -->
        <a href="https://caipiao.ip138.com/shuangseqiu/ " target="_blank" style="text-decoration: none;">
            <div class="sub">双色球返奖比例历史记录》</div>
        </a>

    </div>
</template>

<script>
export default {
    data() {
        return {
            db: [],
            list: [],
        }
    },
    filters: {
        handle_ymd(timestamp) {
            const date = new Date(timestamp * 1000);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        handle_week(timestamp) {
            const date = new Date(timestamp * 1000);
            const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            return weekdays[date.getDay()];
        }
    },
    mounted() {
        this.getdb()
    },
    methods: {
        getdb() {
            let lotteryType = 0
            this.$http.get('/stage-api/pre/record/forecast/runBaseLottery?type=' + lotteryType).then(res => {
                // 兼容多种返回结构：res.data 可能是数组，也可能 res 本身就是数组（裸数组/对象透传）
                const base = res && res.data !== undefined ? res.data : res
                const arr = Array.isArray(base) ? base : (Array.isArray(res) ? res : [])
                if (arr[0] && this.$utils) {
                    arr[0].front_week = this.$utils.timestampToWeekday((arr[0].openTimestamp || 0) * 1000)
                    arr[0].front_ymd = this.$utils.timestampToYMD((arr[0].openTimestamp || 0) * 1000)
                }
                this.db = arr
                const cycle = arr[0] ? arr[0].cycle : ''
                // 奖等列表
                this.$http.get('/stage-api/pre/record/forecast/runLottery?type=' + lotteryType + '&cycle=' + cycle).then(res2 => {
                    const inner = res2 && res2.data !== undefined ? res2.data : res2
                    const list = Array.isArray(inner) ? inner : (inner && inner.rows) || []
                    this.list = list
                }).catch(err => {
                    console.error('ssq 奖等列表加载失败', err)
                    this.list = []
                })
            }).catch(err => {
                console.error('ssq 开奖基本信息加载失败', err)
                this.db = []
                this.list = []
            })
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/commonStyle.scss';

.ssqOrdlt {
    font-size: 14px;

    >.tit {
        display: flex;
        justify-content: space-between;
        margin: 0px 0 10px;
        background-color: $theme_color;
        padding: 10px;
        color: #ffffff;
    }

    .table {
        margin-top: 10px;
        text-align: center;
        font-size: 16px;
        display: flex;

        >div {
            font-weight: bold;

            .tit {
                background-color: $theme_color;
                color: #ffffff;
                padding: 5px;
            }


            &.redBall {
                flex: 6;
                color: red;

            }

            &.blueBall {
                flex: 2;
                color: blue;

                .num {
                    border-left: 0;
                }
            }

            .num {
                border: 1px solid rgba(0, 0, 0, 0.2);

                span {
                    padding: 5px 15px;
                    display: inline-block;
                }
            }
        }
    }

    .table1 {
        text-align: center;
        margin-top: 5px;
        font-size: 12px;
        border-left: 1px solid rgba(0, 0, 0, 0.2);

        >div {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);

            span {
                border-right: 1px solid rgba(0, 0, 0, 0.2);
                padding: 5px 0;

                &:last-child {
                    color: red;
                    font-weight: bold;
                }
            }

            &:nth-child(1) {
                background-color: $theme_color;
                color: #ffffff;
                font-size: 16px;

                span {
                    color: unset;
                }
            }
        }
    }

    .intro {
        margin-top: 10px;
    }

    .sub {
        text-align: right;
        color: red;
        margin-top: 10px;
    }
}
</style>
